module.exports = __webpack_public_path__ + "static/media/card3.5d09e7f9.jpg";